//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-useful-link',
  props: {
    dataElementId: {
      type: String,
      default: '',
    },
    dataDescription: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
  },
}
